import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";

export function bfsCard(title, body) {
    const children_4 = toList(delay(() => {
        let children;
        return append((title != null) ? singleton((children = value(title), react.createElement("div", {
            className: "card-title",
        }, ...children))) : empty(), delay(() => {
            let children_2;
            return (body != null) ? singleton((children_2 = value(body), react.createElement("div", {
                className: "card-body",
            }, ...children_2))) : empty();
        }));
    }));
    return react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_4);
}

export const bfsCardCollapsable = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Shared\\Card.fs") + "#L") + int32ToString(value(18))) + ";") + "System.Tuple`3[System.String,Microsoft.FSharp.Collections.FSharpList`1[Fable.React.ReactElement],System.Boolean]", value("bfsCardCollapsable"), (tupledArg) => {
    let children_6, children_4;
    const isOpen_1 = react.useState(tupledArg[2]);
    const children_10 = [(children_6 = [(children_4 = [(isOpen_1[0]) ? react.createElement("i", {
        className: "fas fa-chevron-down mr-2",
    }) : react.createElement("i", {
        className: "fas fa-chevron-right mr-2",
    }), tupledArg[0]], react.createElement("a", {
        onClick: (_arg) => {
            isOpen_1[1](!(isOpen_1[0]));
        },
    }, ...children_4))], react.createElement("div", {
        className: "card-title",
    }, ...children_6)), CollapsableElement([react.createElement("div", {
        className: "card-body",
    }, ...tupledArg[1]), isOpen_1[0]])];
    return react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_10);
}, undefined, undefined, "Of");

//# sourceMappingURL=Card.fs.js.map
